export class ComponentGranter {
    constructor(response) {
        this.grant_id = response.grant_id;
        this.client_id = response.client_id;
        this.client_name = response.client_name;
        this.client_short_name = response.client_short_name;
        this.granted_date = response.granted_date;
    }
    static isComponentGranter(value) {
        return value instanceof ComponentGranter;
    }
}
